<template>
  <div class="activities">
    <div class="activities__title h1">
      <div>{{'activitiesTitle1' | localize}}&nbsp;</div>
      <div>{{'activitiesTitle2' | localize}}&nbsp;</div>
      <div>{{'activitiesTitle3' | localize}}&nbsp;</div>
      <div>{{'activitiesTitle4' | localize}}&nbsp;</div>
    </div>
    <div class="activities__wrap">
      <div class="activities__web" @click="modalShow(modals.web)"></div>
      <div class="activities__web-text">
        {{'webDescription' | localize}}
        <div class="activities__web-arrow">
          <img src="/img/activities/arrow-web.svg" alt="arrow-web" />
        </div>
      </div>

      <transition name="fade">
        <Modal :dataValue="modals.web" v-if="modals.web.show">
          <p>
            {{'webText' | localize}}
            <br />
            <b>{{'usuallyUse' | localize}}</b>
            <span class="activities__skils">{{'webSkils' | localize}}</span>
          </p>

          <a
            href="#contacts"
            class="btn-primary margin-top"
            v-smooth-scroll
            @click="modalHidden(modals.web)"
          >{{'webButton' | localize}}</a>
        </Modal>
      </transition>

      <a href="https://design.arview.pro" target="_blank" class="activities__ux"></a>
      <div class="activities__ux-text">
        {{'uxDescription' | localize}}
        <div class="activities__ux-arrow">
          <img src="/img/activities/arrow-ux.svg" alt="arrow-ux" />
        </div>
      </div>

      <transition name="fade">
        <Modal :dataValue="modals.ux" v-if="modals.ux.show">
          <p>{{'uxText' | localize}}</p>
          <a
            href="#contacts"
            class="btn-primary margin-top"
            v-smooth-scroll
            @click="modalHidden(modals.ux)"
          >{{'uxButton' | localize}}</a>
        </Modal>
      </transition>

      <div class="activities__mobile" @click="modalShow(modals.mobile)"></div>
      <div class="activities__mobile-text">
        {{'mobileDescription' | localize}}
        <div class="activities__mobile-arrow">
          <img src="/img/activities/arrow-mobile.svg" alt="arrow-mobile" />
        </div>
      </div>

      <transition name="fade">
        <Modal :dataValue="modals.mobile" v-if="modals.mobile.show">
          <p>
            {{'mobileText' | localize}}
            <br />
            <b>{{'usuallyUse' | localize}}</b>
            <span class="activities__skils">{{'mobileSkils' | localize}}</span>
          </p>

          <a
            href="#contacts"
            class="btn-primary margin-top"
            v-smooth-scroll
            @click="modalHidden(modals.mobile)"
          >{{'mobileButton' | localize}}</a>
        </Modal>
      </transition>
    </div>
  </div>
</template>

<script>
import Modal from "@/components/app/Modal";

export default {
  name: "Activities",
  data: () => ({
    modals: {
      web: {
        show: false,
        name: "web",
        title: "WEB DEVELOPMENT",
      },
      ux: {
        show: false,
        name: "ux",
        title: "UI/UX design",
      },
      mobile: {
        show: false,
        name: "mobile",
        title: "MOBILE DEVELOPMENT",
      },
    },
    modalShowed: {},
  }),
  methods: {
    modalShow(modal) {
      this.modalShowed = modal;
      modal.show = true;
      this.$router.push({ path: { modal: modal.name } });
    },
    modalHidden(modal) {
      this.$router.push({ query: "" });
      modal.show = false;
    },
  },
  created() {
    if (this.$route.query.modal) {
      if (this.modals[this.$route.query.modal]) {
        this.modals[this.$route.query.modal].show = true;
      }
    }
    window.onpopstate = () => {
      if (this.$route.query.modal) {
        this.modals[this.$route.query.modal].show = true;
      } else {
        this.modalShowed.show = false;
      }
    };
  },
  components: {
    Modal,
  },
};
</script>

<style lang="scss" scoped>
.activities {
  position: relative;
  width: 100vw;
  height: 950px;
  min-height: 950px;
  overflow: hidden;
  background: url(/img/activities/page3.svg) 50% 50% / cover;

  @media (min-width: 990px) and (max-width: 1199px) {
    min-height: 815px;
    max-height: 815px;
  }

  &__title {
    @extend .text-center;
  }

  &__web,
  &__ux,
  &__mobile {
    @extend .pointer, .absolute, .transition;
    border-radius: 50%;
    transform: scale(1);

    &:hover {
      transform: scale(1.1);
    }
  }

  &__web {
    width: 190px;
    height: 196px;
    background: url(/img/activities/web.svg) 50% 50% / cover;
    right: calc(50% + 405px);
    top: 275px;

    @media (min-width: 990px) and (max-width: 1199px) {
      right: calc(50% + 315px);
      top: 200px;
    }

    &-text {
      @extend .absolute, .text-center;
      width: 216px;
      left: calc(50% - 498px);
      top: 200px;

      @media (min-width: 990px) and (max-width: 1199px) {
        left: calc(50% - 405px);
        top: 135px;
      }
    }

    &-arrow {
      @extend .absolute;
      bottom: -47px;
      left: 59px;
    }
  }

  &__ux {
    width: 160px;
    height: 163px;
    background: url(/img/activities/ux.svg) 50% 50% / cover;
    left: calc(50% - 100px);
    top: 150px;

    @media (min-width: 990px) and (max-width: 1199px) {
      top: 125px;
    }

    &-text {
      @extend .absolute, .text-center;
      width: 217px;
      left: calc(50% - 255px);
      top: 310px;

      @media (min-width: 990px) and (max-width: 1199px) {
        top: 293px;
      }
    }

    &-arrow {
      @extend .absolute;
      top: -48px;
      left: 106px;
    }
  }

  &__mobile {
    width: 200px;
    height: 200px;
    background: url(/img/activities/mobile.svg) 50% 50% / cover;
    left: calc(50% + 365px);
    top: 230px;

    @media (min-width: 990px) and (max-width: 1199px) {
      left: calc(50% + 299px);
      top: 175px;
    }

    &-text {
      @extend .absolute, .text-center;
      width: 212px;
      right: calc(50% - 394px);
      top: 370px;

      @media (min-width: 990px) and (max-width: 1199px) {
        right: calc(50% - 331px);
        top: 311px;
      }
    }

    &-arrow {
      @extend .absolute;
      top: -80px;
      left: 125px;
    }
  }

  &__skils {
    opacity: 0.7;
  }
}

.btn-primary {
  height: 80px;
  line-height: 80px;
  padding: 0 50px;
}
</style>